import helpers from '../../helpers'
import moment from 'moment'

let http

async function responseIsValid (response) {
  if (!response || !response.data.token) { return false }

  try {
    const payload = helpers.unwrap(response.data.token)

    if (!payload || !(payload.aud === 'StrinGnosisAppstream')) return false

    // console.log(payload)

    // store token
    await helpers.storage.set('token', response.data.token)
    await helpers.storage.set('exp', response.data.expiration)

    return true
  } catch (error) {
    // todo: log error
    return false
  }
}

const Auth = {

  install (Vue, options) {
    if (!options || !options.http) { throw new Error('Auth plugin expects http module') }

    http = options.http

    Vue.prototype.$auth = {

      async login (username, password) {
        return new Promise(function (resolve, reject) {
          http.post('account/login', {UserName: username, Password: password}).then(async response => {
            let isValid = await responseIsValid(response)

            if (!isValid) {
              reject(new Error('invalid response'))
            }

            resolve(response)
          })
            .catch(err => {
              console.log(err)
              reject(err)
            })
        })
      },

      async requestAccessToken () {
        let token = await helpers.storage.get('token')

        let config = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

        return http.post('account/sendcode', {}, config)
      },

      async updatePassword (accessCode, oldPassword, newPassword) {
        let token = await helpers.storage.get('token')

        let config = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

        return new Promise((resolve, reject) => {
          http.post('account/update', {AccessToken: accessCode, OldPassword: oldPassword, NewPassword: newPassword}, config).then(async response => {
            if (!response) {
              reject(new Error('invalid response'))
            }

            resolve(response)
          })
            .catch(err => {
              console.log(err)
              reject(err)
            })
        })
      },

      async  isAuthenticated () {
        try {
          let token = await helpers.storage.get('token')
          let exp = await helpers.storage.get('exp')

          if (!token) { return false }

          let payLoad = helpers.unwrap(token)

          if (!payLoad) { return false }

          let tokenExpiration = moment(exp)
          let today = moment(Date.now())
          let time = today.diff(tokenExpiration, 'seconds')
          if (!time > 0) {
            return false
          }

          console.log(tokenExpiration)

          return true
        } catch (error) {
          console.log(error)
          return false
        }
      },
      async logOut () {
        try {
          await helpers.storage.set('token', undefined)
          await helpers.storage.set('exp', undefined)
        } catch (error) {
          console.log('an error occured logging out')
        }
      },

      async resetPassword (username) {
        return new Promise((resolve, reject) => {
          http.post('account/resetpassword', {userName: username}).then(async response => {
            if (!response) {
              reject(new Error('invalid response'))
            }

            resolve(response)
          })
            .catch(err => {
              console.log(err)
              reject(err)
            })
        })
      },
      changePassword (accessCode, userName, newPassword) {
        return new Promise((resolve, reject) => {
          http.post('account/changepassword', {accessToken: accessCode, userName: userName, newPassword: newPassword})
            .then(response => {
              resolve(response)
            }).catch(err => {
              console.log(err)
              reject(err)
            })
        })
      },
      async createDemoUserAccount (firstName, lastName, userName, password, email, companyName, companyAddress, notes) {
        let config = {
          headers: {
            'blade-api-key': Vue.env.get('BLADE_API_KEY')
          }
        }

        return new Promise((resolve, reject) => {
          http.post('account/createdemouser', {firstName: firstName, lastName: lastName, userName: userName, password: password, email: email, companyName: companyName, companyAddress: companyAddress, notes: notes}, config)
            .then(async response => {
              if (!response) {
                reject(new Error('invalid response'))
              }
              resolve(response)
            }).catch(err => {
              console.log(err)
              reject(err)
            })
        })
      }
    }
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/services/auth/index.js